import styled from "styled-components";

export const Wrapper = styled.div`
    max-width: 300px;
    text-align: left;

    p {
        line-height: 1.5;
    }
    
    h2 {
        text-decoration: underline;
    }
    
    li {
        color: var(--font-color-bright);
    }
`;
